export enum DockingPointDisabledReason {
    OutOfService = 1,
    ShouldBeChecked = 2,
    CheckRequired = 3
}